module.exports = __webpack_public_path__ + "./images/p4.JPG?de1c9d6ece81f37b0eb6abdb224029f8";


//////////////////
// WEBPACK FOOTER
// ./src/products/p4.JPG
// module id = 67
// module chunks = 0